import React, { useEffect } from 'react';
import {
  Route,
  Switch,
  useHistory,
  useRouteMatch,
  useLocation,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';

import DuplicateErrorContainer from './DuplicateErrorContainer';
import EasyJoinConfirmationContainer from './EasyJoinConfirmationContainer';
import EasyJoinFormContainer from './EasyJoinFormContainer';
import IdntyRegistrationConfirmationContainer from './IdntyRegistrationConfirmationContainer';
import RegistrationFormContainer from './RegistrationFormContainer';
import ResetContainer from '../../../forgot-password/components/presentational/ResetContainer';
import Spinner from '../../../../shared/_TBComponents/Spinner';
import { USER_TYPE } from '../presentational/IdntyDownloadView';

const ContentWrapper = styled('div')`
  align-self: ${(props) => (props.pathname === '/signup/registration' ? '' : 'center')};
  height: auto;
  width: 100%;
  z-index: 1000;
  display: flex;
  justify-content: center;
`;

const SpinnerContainer = styled('div')`
  background-color: #FFFFFF;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  height: auto;
  padding: 60px 48px;
  position: relative;
  width: 440px;

  @media screen and (max-width: 768px) {
    padding: 40px 32px;
    width: 100%;
    max-width: 440px;
  }

  @media screen and (max-width: 425px) {
    padding: 32px 24px;
    width: 100%;
    max-width: 100%;
  }
`;

const RegistrationContainer = () => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  // isComplete is a shared flag; the pathname guard below makes it IDNTY-specific
  const isIdntyRegistrationComplete = useSelector((state) => state.registration.ui.isComplete);

  const { path } = useRouteMatch('/signup');
  const { pathname } = useLocation();
  const history = useHistory();

  // A trailing slash (e.g. from a copied/re-pasted URL) would otherwise fail
  // the exact-match checks below - non-exact <Route path> matching already
  // tolerates it, so match that here too.
  const normalizedPathname = pathname.replace(/\/+$/, '');

  // If user becomes registered while on the registration page, show spinner
  // to prevent 404 flash while LoginRoute redirect happens
  const isRegisteredOnRegistrationPage = currentUser
    && Object.keys(currentUser).length > 0
    && currentUser.isRegistered === true
    && normalizedPathname === '/signup/registration';

  useEffect(() => {
    if (isIdntyRegistrationComplete && normalizedPathname === `${path}/idnty`) {
      history.push(`${path}/idnty/success?userType=${USER_TYPE.NEW_USER}`);
    }
  }, [isIdntyRegistrationComplete, normalizedPathname, history, path]);

  if (isRegisteredOnRegistrationPage) {
    return (
      <ContentWrapper>
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      </ContentWrapper>
    );
  }

  return (
    <ContentWrapper pathname={normalizedPathname}>
      <Switch>
        <Route
          path={`${path}/duplicate-error`}
        >
          <DuplicateErrorContainer />
        </Route>
        <Route
          path={`${path}/easy-join`}
        >
          <EasyJoinFormContainer />
        </Route>
        <Route
          path={`${path}/easy-join-confirmation`}
        >
          <EasyJoinConfirmationContainer />
        </Route>
        <Route
          path={`${path}/registration`}
        >
          <RegistrationFormContainer />
        </Route>
        <Route
          path={`${path}/idnty/success`}
        >
          <IdntyRegistrationConfirmationContainer />
        </Route>
        <Route
          path={`${path}/idnty/reset-password`}
        >
          <ResetContainer isIdnty />
        </Route>
        <Route
          path={`${path}/idnty`}
        >
          <RegistrationFormContainer isIdnty />
        </Route>
      </Switch>
    </ContentWrapper>
  );
};

export default RegistrationContainer;
